import { Grid, useMediaQuery } from "@mui/material"
import { FC, useEffect, useState } from "react"
import { EmbeddingProps } from "../../pages/Embedding/interface"
import CustomizedColorInput from "../CreateForm/ColorBase"
import FileUploadDialog from "../CreateForm/DialogBase/FileUploadDialog"
import CustomizedInput from "../CreateForm/InputBase"
import { ChooseYourFileButton, EditButton } from "../Custom/Buttons"
import { FontTitleSectionContainer } from "../CustomCss/styled"
import './style.scss'
const initial = {
  mode: "side-tab",
  customIcon: "",
  buttonText: "",
  buttonColor: "#000"
}
interface SideTabScreenComponentProps {
  setWidgetConfigDetails: any;
  widgetConfigDetails?: any;
}
type Props = EmbeddingProps & SideTabScreenComponentProps
const SideTabScreenComponent: FC<Props> = ({ editUUID, setWidgetConfigDetails, widgetConfigDetails }) => {
  const [embedData, setEmbedData] = useState(initial)
  const [editColor, setEditColor] = useState(false)
  const [uploadIcon, setUploadIcon] = useState(false)
  const isLessThan1440 = useMediaQuery("(max-width:1439px)");

  useEffect(() => {
    setWidgetConfigDetails((prev: any) => {
      return {
        ...prev,
        customIcon: embedData.customIcon,
        buttonText: embedData.buttonText,
        buttonColor: embedData.buttonColor

      }
    })
  }, [embedData])

  useEffect(() => {
    if (widgetConfigDetails?.mode === "side-tab" && widgetConfigDetails?.customIcon !== undefined && widgetConfigDetails?.buttonText !== undefined && widgetConfigDetails?.buttonColor !== undefined) {
      setEmbedData(widgetConfigDetails)
    }
  }, [widgetConfigDetails.id])

  return (
    <div className="sideTabScreen">
      <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
        Custom icon
      </FontTitleSectionContainer>
      <Grid item xs={6}>
        <CustomizedInput
          placeholder=""
          value={embedData.customIcon}
          onChange={(e: any) => setEmbedData((prev) => ({ ...prev, customIcon: e.target.value }))}
          type="url"
        />
        <ChooseYourFileButton
          onClick={(e: any) => {
            e.preventDefault();
            setUploadIcon(true);
          }}
        />
        <FileUploadDialog
          open={Boolean(uploadIcon)}
          submitHandler={(e?: string) => { setEmbedData((prev) => ({ ...prev, customIcon: e || "" })); setUploadIcon(false) }}
          editUUID={editUUID}
        />
      </Grid>
      <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
        Button Text
      </FontTitleSectionContainer>
      <CustomizedInput
        placeholder=""
        value={embedData.buttonText}
        onChange={(e: any) => setEmbedData((prev) => ({ ...prev, buttonText: e.target.value }))}
        type="url"
      />
      <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
        Button color
      </FontTitleSectionContainer>
      <div className="sideTabButtonColor">
        <div className="sideTabButtonColorName">
          <CustomizedColorInput
            open={editColor}
            closeHandler={() => setEditColor(false)}
            color={embedData.buttonColor}
            setColor={(value: any) => {

              setEmbedData((prev) => ({ ...prev, buttonColor: value }))
            }}
          />
          <span>{embedData.buttonColor}</span>
        </div>
        <EditButton onClick={() => setEditColor(true)}
          variant="contained"
          size="small" />
      </div>
    </div>
  )
}
export default SideTabScreenComponent